module.exports = __webpack_public_path__ + "static/21-img-1-466f1bfa13d383c2a518adf5996f5cf2.jpg";